<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-80">
    <div class="relative bg-surface-0 dark:bg-surface-900 rounded-xl p-6 w-[90%] max-w-[800px] max-h-[90vh] overflow-y-auto text-surface-700 dark:text-surface-0 border border-surface-200 dark:border-surface-700 flex flex-col">
      <!-- 닫기 버튼 -->
      <div class="flex justify-between items-center mb-6 pb-4 border-b border-surface-200 dark:border-surface-700">
        <h2 class="m-0 text-2xl">자산정보 조회(QR스캔)</h2>
        <Button icon="pi pi-times" class="p-button-text p-button-rounded p-button-icon-only" @click="emit('close')" />
      </div>
      <!-- QR스캐너 -->
      <QrScanner @scanned="onScan" />
      <!-- 스캔 결과 표시 -->
      <div class="scan-result mt-4">
        <div v-if="assetNumber" class="">
          <div class="mt-2 pb-2 border-b border-gray-600 font-bold text-center">검색된 자산 정보</div>
          <span class="text-primary ml-2" hidden>{{ assetNumber }}</span>
          <ul v-if="assetDetail" class="mt-4 text-gray-700 text-sm dark:text-gray-300 list-disc list-inside space-y-1 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
            <li class="">자산번호 : {{ assetDetail.assetNumber }}</li>
            <li class="">자산ID : {{ assetDetail.id }}</li>
            <li class="">주소 : {{ assetDetail.address }}</li>
            <li class="">자산명 : {{ assetDetail.assetName }}</li>
            <li>모델명: {{ assetDetail.modelName }}</li>
            <li
                v-for="([key, value], index) in Object.entries(JSON.parse(assetDetail.assetExplain))"
                :key="index"
            >
              <span class="">{{ key }} : </span>
              <span class="text-gray-400">{{ value }}</span>
            </li>
          </ul>
        </div>
        <div v-else class="text-gray-400 text-center">QR코드를 스캔하세요.</div>
        <div v-if="assetDetailError" class="text-red-500 mt-2">{{ assetDetailError }}</div>
      </div>
      <!-- 자산 상세 조회 버튼 -->
      <div class="flex justify-center mt-6">
        <Button
          label="자산 상세 조회"
          icon="pi pi-search"
          :disabled="!assetNumber"
          @click="emit('asset', assetNumber)"
          class="w-60"
        />
      </div>
      <!-- 자산 상세 모달 (Asset.vue) - 중첩 오버레이 -->
      <div v-if="showAssetModal" class="fixed inset-0 z-60 flex justify-center items-center bg-black bg-opacity-80">
        <div class="relative bg-surface-0 dark:bg-surface-900 rounded-xl p-6 w-[90%] max-w-[800px] max-h-[90vh] overflow-y-auto text-surface-700 dark:text-surface-0 border border-surface-200 dark:border-surface-700 flex flex-col items-center">
          <button class="absolute top-4 right-4 z-10 bg-white rounded-full shadow p-2" @click="showAssetModal = false">
            <i class="pi pi-times text-2xl text-gray-700"></i>
          </button>
          <div class="w-full h-full bg-white rounded-none overflow-auto">
            <Asset :asset-number="assetNumber" @close="showAssetModal = false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import QrScanner from '@/components/QrScanner.vue';
// import Asset from './Asset.vue';
import Button from "primevue/button";
import api from '@/api';
import fastapi from "@/lib/api";

const props = defineProps({
  visible: Boolean
});
const emit = defineEmits(['close', 'asset']);

const assetNumber = ref('');
const showAssetModal = ref(false);
const assetDetail = ref(null);
const assetDetailError = ref('');

function onScan(result) {
  if (result) {
    assetNumber.value = result;
    fetchAssetDetail(result);
    // emit('asset', assetNumber)
  }
}

async function fetchAssetDetail(assetNum) {
  try {
    const response = await fastapi(
      `GET`, 
  `/assets/search/${assetNum}`,
        null,
        null,
        null,
        { useToken: true },
    );
    assetDetail.value = response;
    assetDetailError.value = '';
  } catch (e) {
    assetDetail.value = null;
    assetDetailError.value = '자산 정보를 불러오지 못했습니다.';
  }
}
</script>

<style scoped>
.scan-result {
  font-size: 1.1rem;
}
</style> 